import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const filterButtonStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    border: "none",
    height: '35px',
    borderRadius: "4px",
    padding: '0 15px'
};

const Cateringsoverview = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const { showLoader, hideLoader } = useLoader();
    const handleExport = () => {
        if (filteredData.length === 0) {
            alert("There is no data to export for the selected date.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = ["S.NO", "Order ID", "Date", "Time", "Category", "Type", "Name", "Payment", "Status", "Amount", "Feedback", "Ratings"];

        const csvRows = filteredData.map((item, index) => [
            index + 1,
            item.orderId || 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleDateString() : 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A',
            item.category || 'N/A',
            item.service || 'N/A',
            item.userName || 'N/A',
            item.paymentMethod || 'N/A',
            item.status || 'N/A',
            item.grandTotal !== undefined ? Math.round(item.grandTotal) : 'N/A',
            item.feedback || 'N/A',
            item.ratings || 'N/A'
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "orders.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        const controller = new AbortController();

        const fetchOrders = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const headers = token ? { Authorization: `Bearer ${token}` } : {};

                const res = await fetch(
                    "https://backend.maamaas.com/catering/api/admin/orders/all",
                    {
                        method: "GET",
                        headers,
                        signal: controller.signal,
                    }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const fetchedApiData = await res.json();
                setData(Array.isArray(fetchedApiData) ? fetchedApiData : []);
                setFilteredData(Array.isArray(fetchedApiData) ? fetchedApiData : []);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Fetching error:", err);
                    setData([]);
                }
            } finally {
                hideLoader();
            }
        };

        fetchOrders();
        return () => controller.abort();
    }, []);

    // Filter when date changes
    useEffect(() => {
        if (!selectedDate) {
            setFilteredData(data);
            return;
        }

        const selected = new Date(selectedDate);
        selected.setHours(0, 0, 0, 0);
        const nextDay = new Date(selected);
        nextDay.setDate(selected.getDate() + 1);

        const filtered = data.filter(item => {
            const orderDate = new Date(item.orderDateAndTime);
            return orderDate >= selected && orderDate < nextDay;
        });

        setFilteredData(filtered);
    }, [selectedDate, data]);

    return (
        <div>
            <div className="row" style={{ marginTop: '-5px' }}>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div style={{ overflowY: 'auto', height: 'calc(85vh - 40px)', scrollbarWidth: 'none' }}>
                        {/* Date Picker and Export Button */}
                        <div
                            className="d-flex flex-wrap align-items-center mb-2 pt-3 rounded ps-0"
                            style={{ gap: "10px" }}
                        >
                            <div>
                                <input
                                    type="date"
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    style={filterSelectStyle}
                                />
                            </div>

                            <div style={{ marginLeft: "auto" }}>
                                <button
                                    type="button"
                                    className="btn btn-sm fw-bold"
                                    style={filterButtonStyle}
                                    onClick={handleExport}
                                >
                                    Export
                                </button>
                            </div>
                        </div>

                        {/* Orders Table */}
                        <div className="table-responsive rr pe-2">
                            <table
                                className="table-striped table-bordered align-middle"
                                style={{ fontSize: "0.95rem", width: "100%" }}
                            >
                                <thead>
                                    <tr>
                                        <th style={tableHeaderStyle}>OrderID</th>
                                        <th style={tableHeaderStyle}>VendorID</th>
                                        <th style={tableHeaderStyle}>Location</th>
                                        <th style={tableHeaderStyle}>Date</th>
                                        <th style={tableHeaderStyle}>Time</th>
                                        <th style={tableHeaderStyle}>Category</th>
                                        <th style={tableHeaderStyle}>Payment</th>
                                        <th style={tableHeaderStyle}>Status</th>
                                        <th style={tableHeaderStyle}>Amount</th>
                                        <th style={tableHeaderStyle}>Feedback</th>
                                        <th style={tableHeaderStyle}>Ratings</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredData.length ? (
                                        filteredData.map((item, index) => (
                                            <tr
                                                key={item.orderId || index}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                                                }}
                                            >
                                                <td style={tableCellStyle}>{item.orderId || "-"}</td>
                                                <td style={tableCellStyle}>#{item.vendorId || "-"}</td>
                                                <td style={tableCellStyle}>{item.location || "-"}</td>
                                                <td style={tableCellStyle}>
                                                    {item.orderDateAndTime
                                                        ? new Date(item.orderDateAndTime).toLocaleDateString()
                                                        : "-"}
                                                </td>
                                                <td style={tableCellStyle}>
                                                    {item.orderDateAndTime
                                                        ? new Date(item.orderDateAndTime).toLocaleTimeString([], {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        })
                                                        : "-"}
                                                </td>
                                                <td style={tableCellStyle}>{item.orderService || "-"}</td>
                                                <td style={tableCellStyle}>{item.paymentMethod || "-"}</td>
                                                <td style={tableCellStyle}>{item.paymentStatus || "-"}</td>
                                                <td style={tableCellStyle}>
                                                    ₹{item.total !== undefined ? Math.round(item.total) : "-"}
                                                </td>
                                                <td style={tableCellStyle}>{item.feedback || "-"}</td>
                                                <td style={tableCellStyle}>
                                                    {[1, 2, 3, 4, 5].map((star) => (
                                                        <span
                                                            key={star}
                                                            style={{
                                                                color:
                                                                    item.ratings && Number(item.ratings) >= star
                                                                        ? "#FFD700"
                                                                        : "#e4e5e9",
                                                                fontSize: 18,
                                                                marginRight: 2,
                                                            }}
                                                        >
                                                            ★
                                                        </span>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="11" style={{ ...tableCellStyle, fontStyle: "italic" }}>
                                                No orders found for this date.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    padding: 6,
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: 6,
};
const filterSelectStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px"
};
export default Cateringsoverview;
